import { computed } from 'vue';

import { useSessionStorage } from './storage/useSessionStorage';

export const useLanguage = ()  => {
  const language =  useSessionStorage('language', '');

  const storeLanguage = (lang: string): void => {
    language.value = lang;
  };

  const userLanguage = computed<string>(() => language.value);

  return {
    storeLanguage,
    userLanguage,
  };
};